export default __webpack_public_path__ + "media/onboarding/control-a883842c.gif";